import $ from 'jquery';

$(document).ready(() => {
//recherche load more
    function checkLoadButton() {
        $('#load').attr(
            'disabled',
            $('.s').not('.filter').filter('.hide').length === 0
        );
        if ($('.s').not('.filter').filter('.hide').length > 0) {
            $('.loader-wrapper').removeClass('mb-30 mb-lg-60');
            $('.loader-wrapper').addClass('mb-50 mb-lg-90');
            $('.loader-wrapper .bg-white-shadow').addClass('pb-80');
        }
    }

    function loadMoreSearch(){
        let allContents = $('.s');
        let loadButton = $('#load');
        //console.log('allContents', allContents);

        // Au chargement, on affiche les 10 premiers uniquement
        allContents.slice(10).addClass('hide');
        checkLoadButton();

        loadButton.on('click', function() {
            allContents.not('.filter').filter('.hide').slice(0, 10).removeClass('hide');
            checkLoadButton()
        });
    }
    loadMoreSearch();
})

